import { object } from 'prop-types';
import { Helmet } from 'react-helmet';
import { PageHeader as PageHeaderAntDesign } from '@ant-design/pro-components';

const PageHeader = ({ icon, title, ...props }) => (
    <>
        <Helmet>
            <title>{title}</title>
        </Helmet>
        <PageHeaderAntDesign
            avatar={{
                size: 'large',
                ...icon,
            }}
            title={title}
            style={{ ...props.style, padding: '16px 24px' }}
            {...props}
        />
    </>
);

PageHeader.propTypes = {
    icon: object.isRequired,
};

export { PageHeader };
